module.exports = __webpack_public_path__ + "static/msglen-78def5ef29de201d0112686fdf80d138.svg";